import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ITileInstance } from "../../../interfaces/tiles/definition-helpers/tile-definition.interface";

export interface IRichTextConfiguration {
  text: string;
}

type TRichTextContentCarrier = {
  text?: string | null;
  richtext?: string | null;
  richText?: string | null;
};

export type TRichTextInstance = ITileInstance & {
  configuration?: IRichTextConfiguration & TRichTextContentCarrier;
} & TRichTextContentCarrier;

@Component({
  selector: 'rich-text-tile',
  standalone:true,
  imports: [
    CommonModule,
  ],
  template: `
    <div
      class="rich-text-tile-content"
      [class.rich-text-tile-content--empty]="!resolvedText"
      [innerHTML]="resolvedText"
    ></div>
  `,
  styles: `
    .rich-text-tile-content {
      display: block;
      overflow-wrap: anywhere;
    }

    .rich-text-tile-content--empty {
      min-height: 100px;
    }
  `,
})
export class RichTextTileComponent {
  @Input() tileInstance!: TRichTextInstance;

  get resolvedText(): string {
    return [
      this.tileInstance?.configuration?.text,
      this.tileInstance?.configuration?.richText,
      this.tileInstance?.configuration?.richtext,
      this.tileInstance?.text,
      this.tileInstance?.richText,
      this.tileInstance?.richtext,
    ].find((value): value is string => typeof value === 'string' && value.trim().length > 0) ?? '';
  }
}
